// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"483":"47940013","806":"47940013"}[chunkId] + ".chunk.css";
};